import uniqBy from 'lodash/uniqBy';
import { BookingListResponseData } from '../../types';

interface UpdateQuerySecondArgument {
  fetchMoreResult?: BookingListResponseData;
}

export const updateQuery = (prev: BookingListResponseData, { fetchMoreResult }: UpdateQuerySecondArgument) => {
  if (!fetchMoreResult) {
    return prev;
  }

  const { bookings = [], hasMore = false } = fetchMoreResult.bookingList;
  return {
    bookingList: {
      ...prev.bookingList,
      bookings: uniqBy([...prev.bookingList.bookings, ...bookings], 'id'),
      hasMore,
    },
  };
};
